import { QueryClient } from "@tanstack/react-query";
//#region src/modules/core/data/client.ts
var client = new QueryClient({ defaultOptions: { queries: { networkMode: "offlineFirst" } } });
//#endregion
export { client };
